import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { InstantDequipToolBehavior } from '../../canvas/tooling/InstantDequipToolBehavior';

export const objectTool = defineToolWithCommonBehaviors({
    id: 'objectTool',
    label: 'Insert Tool',
    category: 'design',
    icon: 'deqo://icons/hero/plus-circle',
    weight: 5010,
    // shortcut: 'S',
    behaviors: [InstantDequipToolBehavior]
});

